import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Copy, Search } from "lucide-react";

export default function DuplicateDialog({ dup, onCancel, onPasteAgain, onFind }) {
  const what = dup?.kind === "file" ? "file" : "link";
  const where = dup?.title?.title_name;
  return (
    <AlertDialog open={!!dup} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent data-testid="duplicate-dialog" className="bg-[#121212] border-[#27272A] text-[#F3F4F6] w-[calc(100%-2rem)] max-w-sm rounded-2xl p-5">
        <AlertDialogHeader className="text-left">
          <AlertDialogTitle className="font-heading text-lg leading-snug break-words">
            {where ? <>That {what} already exists in “{where}”</> : <>That {what} already exists</>}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-[#9CA3AF]">
            {where ? "Do you want to paste it here again, or go find it in that note?" : "Do you want to paste it again, or find it in the chat?"}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex flex-col gap-2 pt-1">
          <Button data-testid="duplicate-find-btn" onClick={onFind} className="w-full h-10 rounded-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white">
            <Search className="h-4 w-4 mr-1.5" /> {where ? "Go to that note" : "Find it in the chat"}
          </Button>
          <div className="grid grid-cols-2 gap-2">
            <AlertDialogCancel data-testid="duplicate-cancel-btn" className="mt-0 h-10 rounded-full bg-transparent border-[#27272A] text-[#9CA3AF] hover:bg-[#1E1E1E] hover:text-[#F3F4F6] focus-visible:ring-0 focus-visible:ring-offset-0">
              Cancel
            </AlertDialogCancel>
            <Button data-testid="duplicate-paste-again-btn" variant="outline" onClick={onPasteAgain} className="h-10 rounded-full bg-[#1E1E1E] border-[#27272A] text-[#F3F4F6] hover:bg-[#27272A] hover:text-white">
              <Copy className="h-4 w-4 mr-1.5" /> Paste again
            </Button>
          </div>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
